import React, {useState} from "react";
import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import EditGameModalWindow from "./EditGameModalWindow";
import {Badge, OverlayTrigger, Tooltip} from "react-bootstrap";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditComponent from "./EditComponent";
import * as UserService from "../../api/UserService";
import * as PaymentService from "../../api/PaymentsService";
import GamesListRowVideos from "./GamesListRowVideos";
import DialogComponent from "../DialogComponent";
import DeleteComponent from "./DeleteComponent";
import PayButtonComponent from "./PayButtonComponent";
import DeleteComponentDisabled from "./DeleteComponentDisabled";
import PayGameModal from "./PayGameModal";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import {trySetTimeout} from "../../hooks/trySetTiemout";
import {useTranslation} from "react-i18next";
import {useEffectOnce} from "../../hooks/useEffectOnce";

function GamesListRow(props) {
    const [linkCopied, setLinkCopied] = useState(false)
    const [editable, setEditable] = useState(false)
    const [description, setDescription] = useState(props.description)
    const [recordingStatus, setRecordingStatus] = useState(props.game.recording_status)
    const [mentorVideos, setMentorVideos] = useState([])
    const [playerVideos, setPlayerVideos] = useState([])
    const [deleteModalOpened, setDeleteModalOpened] = useState(false)
    const [paymentModalOpened, setPaymentModalOpened] = useState(false)
    const [disablePayButtons, setDisablePayButtons] = useState(false)
    const [successPayment, setSuccessPayment] = useState(undefined)
    const [gamePrice, setGamePrice] = useState(undefined)
    const { t } = useTranslation('translation', { keyPrefix: 'gamesListPage' });

    function resolveDice() {
        if (props.game.is_auto_dice === true) {
            return t('autoDice')
        }
        return t('manualDice')
    }

    useEffectOnce(() => {
        if(props.description) {
            getProcessedRecordings()
        }
    })

    function openDescriptionAndPullRecordings(event) {
        getProcessedRecordings()
        openDescription(event)
    }

    function openDescription(event) {
        if (description === true) {
            setDescription(false)
        } else {
            setDescription(true)
        }
        if (event.stopPropagation) event.stopPropagation();
    }

    function copyUrlToClipboard(event) {
        navigator.clipboard.writeText(window.location.host + `/game/${props.game.id}?player`);
        setLinkCopied(true)
        trySetTimeout(() => {
            setLinkCopied(false)
        }, 5000)

        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    function openEditGameModal(event) {

        setEditable(true)
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    function openDeleteModal(event) {

        setDeleteModalOpened(true)
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    function openPaymentModal(event) {
        PaymentService.getGameRemainingPrice(props.game.id, (jres) => {
            setGamePrice(jres.remaining)
            setPaymentModalOpened(true)
        }, () => {
        })
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    function closeEditGameModal() {
        setEditable(false)
    }

    function closePaymentModal() {
        setPaymentModalOpened(false)
    }

    function openTheGame() {
        window.open(`/game/${props.game.id}`, '_blank')
    }

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    function resolvePlayerRequest() {
        let request = props.game.user_request
        if (request === null) {
            return "-"
        } else {
            return request
        }
    }

    function startVideoProcessing() {
        UserService.processGameRecordings(props.game.id, () => {
            setRecordingStatus("processing")
        }, () => {
        })
    }

    function prepProcessedVideos(videos) {
        let mentor = []
        let player = []

        videos.forEach(
            video => {
                if (video["user"] === "mentor") {
                    mentor.push(video)
                }
                if (video["user"] === "player") {
                    player.push(video)
                }
            }
        )
        setMentorVideos(mentor)
        setPlayerVideos(player)
    }

    function getProcessedRecordings() {
        if (recordingStatus === "processed") {
            UserService.getProcessedRecordings(props.game.id, prepProcessedVideos, () => {
            })
        }
    }

    function deleteGame() {
        UserService.deleteGame(props.game.id, () => {
            props.updataGames()
            props.updateBalance()
            setDeleteModalOpened(false)
        }, () => {
        })
    }

    function openGameCommentsPage() {
        window.open(`/game_comments/${props.game.id}`, "_blank")
    }

    function pay() {
        setDisablePayButtons(true)
        PaymentService.payGame(
            props.game.id,
            () => {
                setSuccessPayment(true)
                trySetTimeout(() => {
                    setDisablePayButtons(false)
                    setPaymentModalOpened(false)
                    setSuccessPayment(undefined)
                }, 1000)
                props.updataGames()
                props.updateBalance()
            },
            () => {
                window.alert("Payment failed")
            }
        )
    }

    return (
        <>
            <div className={description
                ? `${cabinetStyle.gameListRowNewContainer} ${cabinetStyle.commonTileExtended}`
                : `${cabinetStyle.gameListRowNewContainer} ${cabinetStyle.commonTile}`}>
                <div
                    className={cabinetStyle.gameListRowThreeControls}
                    onClick={openTheGame}>
                    <div className={Style.h5Heading}>
                        <div>
                            <FiberManualRecordIcon
                                style={{fontSize: "small"}}
                                sx={props.game.is_over ? {color: '#EBE5FC'} : {color: '#28A745'}}
                            ></FiberManualRecordIcon>
                            <span style={{marginLeft: "7px"}}>
                                {props.game.is_trial_game &&
                                    <Badge bg="secondary" style={{
                                        maxWidth: "50px",
                                        fontSize: "xx-small",
                                        marginRight: "12px"
                                    }}>{t('trialGame')}</Badge>}
                                {props.game.name} [{t('player')}: {props.game.player_name}]
                            </span>
                        </div>

                    </div>
                    {!props.game.require_payment &&
                        <OverlayTrigger
                            placement="bottom"
                            delay={{show: 50, hide: 400}}
                            overlay={renderTooltip(t('copyPlayerLink'))}
                        >
                            <div className={cabinetStyle.controlsCopy} onClick={copyUrlToClipboard}>
                                <ContentCopyIcon sx={linkCopied ? {color: '#64dd17'} : {color: '#ede7f6'}}/>
                            </div>
                        </OverlayTrigger>}
                    {props.game.require_payment &&
                        <PayButtonComponent toolTipText={t('payTheGame')}
                                            openOnClick={openPaymentModal}></PayButtonComponent>
                    }
                    <EditComponent toolTipText={t('editGame')} openOnClick={openEditGameModal}></EditComponent>
                    {(!props.game.is_started || props.game.is_trial_game) &&
                        <DeleteComponent toolTipText={t('deleteGame')} openOnClick={openDeleteModal}></DeleteComponent>
                    }
                    {(props.game.is_started && !props.game.is_trial_game) &&
                        <DeleteComponentDisabled toolTipText={t('gameInProgress')}></DeleteComponentDisabled>
                    }
                </div>
                <div className={cabinetStyle.gameDetailsIcon} onClick={openDescriptionAndPullRecordings}>
                    {description
                        ? <KeyboardArrowUpIcon></KeyboardArrowUpIcon>
                        : <KeyboardArrowDownOutlinedIcon></KeyboardArrowDownOutlinedIcon>}
                </div>

                {
                    description &&
                    <div className={cabinetStyle.gameDetailsView}>
                        <div>
                            <div><b>{t('dice')}</b> : {resolveDice()}</div>
                            <div><b>{t('playerPosition')}</b> : {props.game.current_user_position}</div>
                            <div><b>{t('playerRequest')}</b>: {resolvePlayerRequest()}</div>
                            {props.game.recording_status != null && props.game.recording_status !== "allowed" &&
                                <GamesListRowVideos recordingStatus={recordingStatus}
                                                    startVideoProcessing={startVideoProcessing}
                                                    mentorVideos={mentorVideos}
                                                    playerVideos={playerVideos}></GamesListRowVideos>
                            }
                        </div>
                        <div>
                            <OverlayTrigger
                                placement="bottom"
                                delay={{show: 50, hide: 400}}
                                overlay={renderTooltip(t('allGameComments'))}
                            >
                                <DescriptionOutlinedIcon style={{fontSize: "xx-large"}}
                                                         onClick={openGameCommentsPage}></DescriptionOutlinedIcon>
                            </OverlayTrigger>
                        </div>
                    </div>

                }
            </div>
            {editable && <EditGameModalWindow onClose={closeEditGameModal}
                                              gameName={props.game.name}
                                              playerName={props.game.player_name}
                                              isAutoDice={props.game.is_auto_dice} gameId={props.game.id}
                                              videoAllowed={props.game.video_allowed}
                                              premiumVideo={props.game.premium_video}
                                              selectedStyle={props.game.game_field_style_id}
                                              selectedDeck={props.game.deck_id + "-" + props.game.deck_type}
                                              updataGames={props.updataGames}/>}
            {deleteModalOpened && <DialogComponent
                onClose={() => {
                    setDeleteModalOpened(false)
                }}
                onConfirm={deleteGame}
                title={t('deleteGame') + props.game.name + "[" + t('player') + ": " + props.game.player_name + "] ?"}
            ></DialogComponent>}
            {paymentModalOpened &&
                <PayGameModal onClose={closePaymentModal}
                              onConfirm={pay}
                              price={gamePrice}
                              game_name={props.game.name}
                              disableControls={disablePayButtons}
                              successPayment={successPayment}
                ></PayGameModal>
            }
        </>

    )

}

export default GamesListRow;